/**
 *
 * @param {String} time e.g. '09:30'
 * @returns Object e.g. { hours: 8, minutes: 0 }
 */
export default function parseTimeStringToObject(time) {
  // e.g. ['09', '30']
  const splitTime = time.split(':')

  // If not a valid time, return base value
  if (!splitTime || splitTime.length !== 2) {
    throw new Error(`Invalid time format. Should be HH:mm. Received: ${time}`)
  }

  const parseHours = parseInt(splitTime[0])
  const parseMinutes = parseInt(splitTime[1])

  if (isNaN(parseHours)) {
    throw new Error(
      `Unable to parse hours time part. Received: ${splitTime[0]}`
    )
  }

  if (isNaN(parseMinutes)) {
    throw new Error(
      `Unable to parse minutes time part. Received: ${splitTime[1]}`
    )
  }

  return { hours: parseHours, minutes: parseMinutes }
}
